export default __webpack_public_path__ + "static/media/safe.01792c0b.png";